function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M6.64 3.76c.6.07 1.2.4 1.46.95.2.5.14 1 .3 1.5.34 1 1.67 1.6 2.66 1.4.9-.1 1.04-1.1.96-1.9-.07-.6-.2-1.4.2-1.9.32-.4.86-.6 1.38-.6.5-.06 1.08 0 1.43.36.44.48.33 1.2.24 1.87-.08.6-.1 1.4.5 1.73.56.3 1.2-.05 1.68-.3l1.3-.8c.3-.2.6-.37.94-.38.4 0 .8.3 1 .72.4.8.1 1.8-.5 2.5-.58.67-4.3.45-5.1 2.3-.78 1.83 1 3.3 1.14 3.97.27 1.27-1.1 1.34-1.94 1-.75-.32-1.74-.74-2.34.25-.3.42.12 2.1-1.47 3.3-1.6 1.2-3.76-.2-2.56-1.6 1.2-1.4.82-2.67.3-3.1-.4-.3-1-.3-1.5-.16-.5.16-.95.46-1.4.7-.58.3-1.23.56-1.86.45-.66-.15-1.25-.7-1.16-1.4.06-.3.23-.5.44-.72.5-.53 1.2-.8 1.86-.98.4-.1 1-.08 1.33-.36.53-.43-.5-1.12-.86-1.26-.6-.2-1.3-.5-1.36-1.1-.06-.4.24-.7.6-.9C5 9 6 9.4 6 8.58c.06-1.6-1.68-2.48-1.7-4-.04-.88 1.72-.86 2.26-.8z"
}), React.createElement("path", {
  d: "M17.76 14.58c-.9-1.35-1.12-2.25.42-2.44 1.54-.18 2.2.1 2.35 1.37.16 1.3-1.88 2.5-2.77 1.1zm3.44 4.74c.1-.66-.14-1.57-.7-1.97-.58-.4-1.38-.27-1.98-.03-.37.15-.7.4-.9.74-.15.27-.2.6-.23.9-.1.3-.1.63.1.9.2.52.8.75 1.3.86.3.08.7.13 1 .05.4-.08.7-.32.9-.63.2-.24.3-.52.33-.82z"
}));

var SvgLocationMud = function SvgLocationMud(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgLocationMud;